import {
  ATTSCHEDULE_LOADING,
  GET_ATTSCHEDULE,
  GET_ATTSCHEDULE_SUCCESS,
  GET_ATTSCHEDULE_FAIL,
  ADD_ATTSCHEDULE_SUCCESS,
  ADD_ATTSCHEDULE_FAIL,
  DELETE_ATTSCHEDULE_SUCCESS,
  DELETE_ATTSCHEDULE_FAIL,
  UPDATE_ATTSCHEDULE_SUCCESS,
  UPDATE_ATTSCHEDULE_FAIL,
  ATTSCHEDULE_RESET
} from "./actionType";

const INIT_STATE = {
  attSchedules: [],
  error: {},
};

const AttSchedule = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ATTSCHEDULE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ATTSCHEDULE:
          return {
            ...state,
            attSchedules: action.payload.data,
            isAttScheduleCreated: false,
            isAttScheduleSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ATTSCHEDULE_FAIL:
      switch (action.payload.actionType) {
        case GET_ATTSCHEDULE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAttScheduleCreated: false,
            isAttScheduleSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ATTSCHEDULE: {
      return {
        ...state,
        isAttScheduleCreated: false,
        loading: true,
      };
    }

    case ATTSCHEDULE_LOADING: {
      return {
        ...state,
        isAttScheduleCreated: false,
        loading: true,
      };
    }

    case ADD_ATTSCHEDULE_SUCCESS:
      return {
        ...state,
        isAttScheduleCreated: true,
        loading: false,
        attSchedules: [action.payload.data, ...state.attSchedules],
      };

    case ADD_ATTSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ATTSCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        attSchedules: state.attSchedules.filter(
          attSchedule => attSchedule.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ATTSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ATTSCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        attSchedules: state.attSchedules.map(attSchedule =>
          attSchedule.id.toString() === action.payload.data.id.toString() ? { ...attSchedule, ...action.payload.data } : attSchedule
        ),
      };

    case UPDATE_ATTSCHEDULE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ATTSCHEDULE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AttSchedule;